// extracted by mini-css-extract-plugin
export default {"about_us":"Vineyard_about_us__wL0Lv","worker_img":"Vineyard_worker_img__EQWhN"};